<app-breadcrumb></app-breadcrumb>
<div class="container" *ngIf="theme$ | async as theme">
  <div class="main-container-download">
    <div class="col">
      <div>
        <p-accordion [dt]="downloadsAccordion">
          <p-accordion-panel value="0">
            <p-accordion-header>
              <span>Download Instructions</span>
            </p-accordion-header>
            <p-accordion-content 
              [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
              <div class="instructions-container">
                <div class="note">
                  <p>
                    <span style="font-weight: 600;">NOTE: </span>
                    Export/Map files are only updated after 09:00 UTC each day. If you download
                    a file before 09:00 UTC, it will not include the latest updates or
                    additional data. To ensure you receive the most current information,
                    please wait until after 09:00 UTC to submit your download request.
                  </p>

                </div>
                <h4>Browser download</h4>
                <ul>
                  <li>Click on the &lt;employeeNumber&gt;.logbook.&lt;type&gt;.csv file
                    that was downloaded
                  </li>
                  <li>The file will automatically download to the default download location</li>
                </ul>
                <h4>Mobile download</h4>
                <ul>
                  <li>Click on the &lt;employeeNumber&gt;.logbook.&lt;type&gt;.csv file
                    that was downloaded
                  </li>
                  <li>You will be prompted to move the file to your device</li>
                  <li>You can select the location to move the file</li>
                  <li>On iOS devices, you can select to save the file to your iCloud Drive or
                    other cloud storage
                  </li>
                  <li>On Android devices, you can select to save the file to your device or
                    other cloud storage
                  </li>
                </ul>
                <h4>Map Files</h4>
                <p>The map files detail the files for the Career Map Projection and Google Earth.
                  The file ending with a .json extension is provided to inform the user
                  of the current map being used in the Career Map Projection and is not available
                  for downloading. The file ending with a .kml extension is provided to
                  allow the user to download the map file and use it in Google Earth.
                  The .kml file can be opened in Google Earth or other mapping applications that
                  support KML files.
                </p>
                <ul>
                  <li><b>Google Earth file:</b>&lt;emplyeeNumber&gt;.logbook_gx.kml</li>
                  <li><b>Career Map Projection file:</b>&lt;emplyeeNumber&gt;.logbook_mp.json</li>
                </ul>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
      <div class="edit-row">
        <div class="section-title">Available Downloads</div>
        <div class="edit-label" (click)="onEdit()">
          {{isEditing ? 'Cancel' : 'Edit'}}
        </div>
      </div>
      <div class="col" *ngIf="csvFiles$ | async as csvFiles; else noBlob">
        <div class="row edit" *ngFor="let file of csvFiles;">
          <a class="download-link" (click)="downloadBlob(file)">
            <div class="download-row"
              [style]="{'border-top-right-radius': isEditing ? '0' : '8px',
              'border-bottom-right-radius': isEditing ? '0' : '8px',
              'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
              <div class="download-col">
                <div class="file-name">{{file.fileName}}</div>
                <div class="data-row">
                  <div>({{formatBytes(file?.blobName?.size || 0)}})</div>
                  <div class="download-label">{{file?.timestamp | formatDateTime}} UTC
                  </div>
                </div>
              </div>
              <div class="download-col">
                <i class="download-icon pi pi-download"></i>
              </div>
            </div>
          </a>
          <div [@fadeOpenClose]="isEditing ? 'open' : 'closed'" class="edit-icon-container"
            (click)="onDeleteConfirm($event, file.fileName)">
            <i class="pi pi-trash"></i>
          </div>
        </div>
      </div>
      <div class="edit-row">
        <div class="section-title">Map Files</div>
      </div>
      <div class="col" *ngIf="mapFiles$ | async as mapFiles; else noBlob">
        <div class="row edit" *ngFor="let mapFile of mapFiles;">
          @if (mapFile.fileName.toLowerCase().endsWith('.kml')) {
          <a class="download-link" (click)="downloadBlob(mapFile)">
            <div class="download-row" 
              [style]="{'border-top-right-radius': isEditing ? '0' : '8px',
              'border-bottom-right-radius': isEditing ? '0' : '8px',
              'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
              <div class="download-col">
                <div class="file-name">{{mapFile.fileName}}</div>
                <div class="data-row">
                  <div>({{formatBytes(mapFile?.blobName?.size || 0)}})</div>
                  <div class="download-label">{{mapFile?.timestamp | formatDateTime}} UTC
                  </div>
                </div>
              </div>
              <div class="download-col">
                <i class="download-icon pi pi-download"></i>
              </div>
            </div>
          </a>
          }
          @else {
          <div class="download-link">
            <div class="download-row disabled-link" 
              [style]="{'border-top-right-radius': isEditing ? '0' : '8px',
              'border-bottom-right-radius': isEditing ? '0' : '8px',
              'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
              <div class="download-col">
                <div class="file-name disabled-link">{{mapFile.fileName}}</div>
                <div class="data-row">
                  <div>({{formatBytes(mapFile?.blobName?.size || 0)}})</div>
                  <div class="download-label">{{mapFile?.timestamp | formatDateTime}} UTC
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          <div [@fadeOpenClose]="isEditing ? 'open' : 'closed'" class="edit-icon-container"
            (click)="onDeleteConfirm($event, mapFile.fileName)">
            <i class="pi pi-trash"></i>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noBlob>
      <div class="row">
        Nothing Downloaded yet.
      </div>
    </ng-template>
  </div>
</div>
<p-confirmPopup #confirmPopupRef>
  <ng-template pTemplate="headless" let-message>
    <div class="confirm-popover-container">
      <i [class]="message.icon" style="font-size: 2rem; color: var(--p-yellow-500)"></i>
      <span>{{message.message}}</span>
      <hr />
      <div class="confirm-popover-buttons">
        <button type="button" class="confirm-button cancel" (click)="confirmPopupRef.onReject()">
          <i class="pi pi-times mr-1"></i>Cancel
        </button>
        <button type="button" class="confirm-button accept" (click)="confirmPopupRef.onAccept()">
          <i class="pi pi-check mr-1"></i>Confirm
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmPopup>